// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "411d95bab7e00a5b3c5f50057e65e941c62f6a9c64679fd2e25eb2ecf7dbb836" + ".css";
};